import { appConfig } from "@/lib/site-config";
import { ImageType } from "@/pages/challenges/types/common";
import {
  closeMiniApp,
  openLink,
  openTelegramLink,
} from "@telegram-apps/sdk-react";

export function isNullOrUndefined<T>(value: T): boolean {
  return value === null || value === undefined;
}

type ImagePriority = "large" | "medium" | "small" | "tiny";

export const getImageByPriority = <T extends ImageType>(
  image: T,
  priority: ImagePriority
): string => {
  if (isNullOrUndefined(image)) {
    return "";
  }

  const { large_url, tiny_url, medium_url, small_url, url } = image;
  const priorityOrder = {
    large: [large_url, medium_url, small_url, tiny_url, url],
    medium: [medium_url, large_url, small_url, tiny_url, url],
    small: [small_url, medium_url, large_url, tiny_url, url],
    tiny: [tiny_url, small_url, medium_url, large_url, url],
  };

  const order = priorityOrder[priority];
  return order.find(Boolean) || "";
};

/* 

*/
/**
 * Constructs the full Telegram username URL by appending the provided username
 *
 * @param username - The Telegram username, which may include or exclude the "@" symbol.
 * @returns The full Telegram username URL as a string.
 *
 * @example
 * ```typescript
 * const username = "@john_doe";
 * const fullUrl = getTelegramFullUsername(username);
 * console.log(fullUrl); // Output: "https://t.me/john_doe"
 * ```
 */
export const getTelegramFullUsername = (username: string): string => {
  const userName = username.replace("@", "");
  return appConfig.telegram.baseUrl + userName;
};

export const openTelegramUsernameLink = (username: string) => {
  const fullUrl = getTelegramFullUsername(username);
  openTelegramLink(fullUrl);
};

export function extractDomain(url: string): string {
  try {
    const { hostname } = new URL(url);
    return hostname;
  } catch {
    return ""; // return empty if it's not a valid URL
  }
}

export const openPublicOffer = ({
  closeApp = false,
}: {
  closeApp?: boolean;
}) => {
  if (openLink.isAvailable() && appConfig.links.privacy) {
    openLink(appConfig.links.privacy, {
      tryInstantView: true,
    });

    setTimeout(() => {
      if (closeMiniApp.isAvailable() && closeApp) {
        closeMiniApp();
      }
    }, 500);
  }
  return false;
};

export async function pasteClipboardContent(): Promise<string> {
  try {
    const clipboardText = await navigator.clipboard.readText();
    return clipboardText;
  } catch (error) {
    console.error("Failed to read clipboard:", error);
    return ""; // fallback if reading fails
  }
}
